import axios from "axios"
const BASE_URL = process.env.REACT_APP_API_URL

class ProgramApi {
  addProgram(data, config) {
    return axios.post(BASE_URL + "/admin/program/create", data, config)
  }

  getProgram(config) {
    return axios.get(BASE_URL + "/admin/program/programDetails", config)
  }

  getProgramByInstitue(institutionCode, category, config) {
    return axios.get(
      `${BASE_URL}/admin/institution/programDetails/${institutionCode}/${category}`,
      config,
    )
  }

  getProgramById(prorgamId, config) {
    return axios.get(
      `${BASE_URL}/admin/program/programDatabyId/${prorgamId}`,
      config,
    )
  }

  updatePorgram(data, config) {
    return axios.put(BASE_URL + "/admin/program/updateProgram", data, config)
  }


  verifyProgram(data, config) {
    return axios.put(BASE_URL + "/admin/program/verify", data, config)
  }


  uploadProgramByExcel(data, config) {
    return axios.post(
      BASE_URL + "/admin/program/uploadProgram",
      data,
      config,
    )
  }
  updateProgramStatus(data, config) {
    return axios.put(BASE_URL + "/admin/program/updateStatus", data, config)
  }
  
  searchCourseAndProgram(config) {
    return axios.get(BASE_URL + "/admin/course/searchCoursesAndPrograms", config)
  }
}

export default new ProgramApi()
